/**
 * Rótulos e selos da agenda (visual v2): prioridade, tipo/status de evento
 * e categoria/status de tarefa, com as cores do tema.
 */
import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'

export const eventTypeLabels: Record<string, string> = {
  AUDIENCIA: 'Audiência',
  REUNIAO: 'Reunião',
  COMPROMISSO: 'Compromisso',
  OUTRO: 'Outro'
}

export const eventStatusLabels: Record<string, string> = {
  SCHEDULED: 'Agendado',
  CONFIRMED: 'Confirmado',
  CANCELLED: 'Cancelado',
  COMPLETED: 'Concluído',
  RESCHEDULED: 'Reagendado'
}

export const taskCategoryLabels: Record<string, string> = {
  PRAZO_PROCESSUAL: 'Prazo Processual',
  ACAO_INTERNA: 'Ação Interna',
  FOLLOW_UP: 'Follow-up',
  DOCUMENTO: 'Documento',
  OUTRO: 'Outro'
}

export const taskStatusLabels: Record<string, string> = {
  PENDING: 'Pendente',
  IN_PROGRESS: 'Em Andamento',
  FOR_REVIEW: 'Em Revisão',
  COMPLETED: 'Concluída',
  CANCELLED: 'Cancelada'
}

/** Selo compacto dos cartões: só urgente (destrutivo) e alta (contorno). */
export function CalendarPriorityFlag({ priority, className }: { priority: string; className?: string }) {
  if (priority === 'URGENT') {
    return <Badge variant="destructive" className={cn('h-4 px-1.5 text-[10px]', className)}>URGENTE</Badge>
  }
  if (priority === 'HIGH') {
    return <Badge variant="outline" className={cn('h-4 px-1.5 text-[10px]', className)}>ALTA</Badge>
  }
  return null
}

/** Selo de prioridade do diálogo de detalhes (mostra o código, como antes). */
export function CalendarPriorityBadge({ priority }: { priority: string }) {
  const variant = priority === 'URGENT' ? 'destructive' : priority === 'HIGH' ? 'default' : priority === 'LOW' ? 'outline' : 'secondary'
  return <Badge variant={variant}>{priority}</Badge>
}
